/**
 * Get user initials from full name, handling null/undefined safely
 * Returns '?' if name is null, undefined, or empty
 */
export const getInitials = (name?: string | null): string => {
  if (!name) return '?';

  const parts = name
    .split(' ')
    .map((part) => part.trim())
    .filter(Boolean);

  if (!parts.length) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();

  return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
};

/**
 * Get display name with fallback for null
 */
export const getDisplayName = (
  name?: string | null,
  fallback = 'Unknown User'
): string => {
  return name || fallback;
};
